import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { useReviewsDialog } from "../../hooks/useReviewsDialog";
import { IPublicReviewsSummaryModel } from "../../models/reviewModels";
import {
  formatAverageRating,
  getReviewsCountLabel,
} from "../../utils/reviewUtility";
import { ReviewContent } from "../ReviewContent/ReviewContent";
import { StarRating } from "../StarRating/StarRating";
import styles from "./ReviewsDialog.module.scss";

interface IReviewsDialogProps {
  visible: boolean;
  studioId?: number;
  summary: IPublicReviewsSummaryModel | null;
  onHide: () => void;
}

export const ReviewsDialog = ({
  visible,
  studioId,
  summary,
  onHide,
}: IReviewsDialogProps) => {
  const { items, hasMore, isLoading, loadMore } = useReviewsDialog(
    studioId,
    visible,
  );

  return (
    <AppDialog
      header="Ревюта"
      visible={visible}
      onHide={onHide}
      className={styles.dialog}
    >
      <div className={styles.root}>
        <RenderWhen condition={!!summary}>
          <div className={styles.root_summary}>
            <span className={styles.root_summary_average}>
              {formatAverageRating(summary?.averageRating ?? 0)}
            </span>
            <div className={styles.root_summary_details}>
              <StarRating value={summary?.averageRating ?? 0} size="medium" />
              <span className={styles.root_summary_count}>
                {getReviewsCountLabel(summary?.count ?? 0)}
              </span>
            </div>
          </div>
        </RenderWhen>

        <ul className={styles.root_list}>
          {items.map((review) => (
            <li key={review.id} className={styles.root_list_item}>
              <ReviewContent review={review} />
            </li>
          ))}
        </ul>

        <RenderWhen condition={hasMore}>
          <div className={styles.root_more}>
            <DefaultButton
              label="Покажи още"
              design="outline"
              width="auto"
              loading={isLoading}
              onClick={loadMore}
            />
          </div>
        </RenderWhen>
      </div>
    </AppDialog>
  );
};
